// admin can add the user inuput field page

import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  MenuItem,
  SelectChangeEvent,
  Select,
  IconButton,
} from '@mui/material';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ThemeProvider } from '@mui/material/styles';
import getTheme from '../../../theme/theme';
import { AddUserFields } from '../../../constants/userrolefields';
import { OrganizationFinal } from '../../subscriptionplans/Subscription';
import { BASEURL, ARROW, AUTOFILL_STYLES } from '../../../constants/Common';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import FloatingButton from '../../usersupport/helpdesk/FloatingButton';

export interface Adduser {
  organization_id: number | null;
  employee_id: string;
  username: string; // Allow any string value for status
  organization?: string;
  email: string;
  password: string;
  createdate: string | Date | null; // Update the type to accept string or Date
  category: string; // Allow any string value for projectaccess
  role: string; // Allow any string value for scheduleaccess
  title: string; // Allow any string value for modulesaccess
  [key: string]: string | number | null | Date | string | undefined;
}

const AddUserPage: React.FC = () => {
  const theme = getTheme();

  const [showPassword, setShowPassword] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const navigate = useNavigate();
  // get the orgif from localStorage
  const storedData = localStorage.getItem('orgid');
  let parsedData: any = null;

  if (storedData) {
    parsedData = JSON.parse(storedData);
  } else {
    navigate('/login')
  }

  const [organizationfinal, setOrganizationFinal] =
    useState<OrganizationFinal | null>(null);
  const [roleOptions, setRoleOptions] = useState<string[]>([]);
  const disableOrganizatioName =
    organizationfinal?.organization?.organization_name;
  const organizationid = parsedData;
  const [newLog, setNewLog] = useState<Adduser>({
    organization_id: organizationid,
    organization_name: disableOrganizatioName,
    employee_id: '',
    username: '',
    email: '',
    password: '',
    category: '',
    role: '',
    title: '',

    createdate: new Date().toISOString(),
  });



  useEffect(() => {
    const fetchOrganization = async () => {
      try {
        const response = await axios.get(
          BASEURL + `/organization/${organizationid}/`,
          {
            headers: {
              Accept: 'application/json',
            },
          }
        );
        setOrganizationFinal(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchOrganization();
  }, [organizationid]);

  const handleInputChange = (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | SelectChangeEvent<string>
  ) => {
    const { name, value } = event.target as
      | HTMLInputElement
      | HTMLTextAreaElement;
    setNewLog({ ...newLog, [name]: value });
  };

  const formatDate = (dateString: string | Date | null): string => {
    if (!dateString) {
      return '';
    }

    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = ('0' + (dateObject.getMonth() + 1)).slice(-2);
    const day = ('0' + dateObject.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsSaving(true)

    try {
      const {
        employee_id,
        organization_id,
        organization_name,
        username,
        email,
        password,
        category,
        role,
        title,
      } = newLog;

      // Check if employee_id is provided
      if (!employee_id) {
        toast.error('Employee ID is required');
        setIsSaving(false);
        return;
      }

      // Check if username is provided
      if (!username) {
        toast.error('Username is required');
        setIsSaving(false);
        return;
      }

      // Check if email is provided and valid
      if (!email) {
        toast.error('Email is required');
        setIsSaving(false);
        return;
      } else if (!/\S+@\S+\.\S+/.test(email)) {
        toast.error('Invalid email address');
        setIsSaving(false);
        return;
      }

      // Check if password is provided
      if (!password) {
        toast.error('Password is required');
        setIsSaving(false);
        return;
      }

      // Check if category is provided
      if (!category) {
        toast.error('Category is required');
        setIsSaving(false);
        return;
      }

      // Check if role is provided
      if (!role) {
        toast.error('Role is required');
        setIsSaving(false);
        return;
      }

      // Check if title is provided
      if (!title) {
        toast.error('Title is required');
        setIsSaving(false);
        return;
      }
      // Check if username already exists
      const checkResponse = await axios.post(BASEURL + '/check-user-exists/', {
        username,  
        email,
      });

      if (checkResponse.data.exists) {
        const field = checkResponse.data.field;
        toast.error(`${field.charAt(0).toUpperCase() + field.slice(1)} already exists.`);
        setIsSaving(false);
        return;
      }

      const payload = {
        organization_id,
        organization_name: disableOrganizatioName,
        employee_id,
        username,
        email,
        password,
        category,
        role,
        title,
      };

      const jsonData = JSON.stringify(payload);
      const response = await axios.post(BASEURL + `/add-user/`, jsonData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      toast.success('User added successfully');
      navigate('/directory');
      //   navigate(`/view-role?role_id=${response.data.id}`);
    } catch (error) {
      setIsSaving(false)
      console.error('Error creating user role:', error);
      toast.error('Failed to add user ');
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  //fetch date

  useEffect(() => {
    const fetchCurrentDate = async () => {
      try {
        const response = await axios.get(BASEURL + `/get-current-date/`);
        const currentDate = response.data.current_date;
        setNewLog((prevLog: any) => ({ ...prevLog, createdon: currentDate }));
      } catch (error) {
        console.error('Error fetching current date:', error);
      }
    };

    fetchCurrentDate();
  }, []);

  //fetch username
  useEffect(() => {
    const fetchUserName = async () => {
      try {
        const response = await axios.get(
          BASEURL + `/userrole/by-organization/${organizationid}/`
        );
        const roleData = response.data;
        setRoleOptions(roleData);
      } catch (error) {
        console.error('Error fetching current date:', error);
      }
    };

    fetchUserName();
  }, []);

  const handleCancelClick = () => {
    navigate('/directory');
  };

  return (
    <ThemeProvider theme={getTheme()}>
      <Box sx={{ mt: '-80px' }}>
        <Typography variant='h6' gutterBottom>
          <Link to={'/useraccount'}>User Account</Link>
          {ARROW} Add New User
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {AddUserFields.map(
              (field) =>
                !['projectcode'].includes(field.name) && (
                  <Grid item xs={12} key={field.name} sx={{ mb: '10px' }}>
                    <Grid container spacing={2} alignItems='center'>
                      <Grid item xs={4}>
                        <Typography>{field.title}</Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <Box sx={{ maxWidth: '350px',...AUTOFILL_STYLES(theme)}}>
                          {field.name === 'organization' ? (
                            <TextField
                              fullWidth
                              variant='outlined'
                              name={field.name}
                              value={disableOrganizatioName || ''}
                              onChange={handleInputChange}
                              margin='normal'
                            />
                          ) : field.name === 'role' ? (
                            <Select
                              fullWidth
                              variant='outlined'
                              name={field.name}
                              value={
                                newLog[field.name] !== null
                                  ? (newLog[field.name] as string)
                                  : ''
                              }
                              onChange={handleInputChange}
                            >
                              {roleOptions.map((option) => (
                                <MenuItem key={option} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                          ) : field.type === 'dropDown' ? (
                            <Select
                              fullWidth
                              variant='outlined'
                              name={field.name}
                              value={
                                newLog[field.name] !== null
                                  ? (newLog[field.name] as string)
                                  : ''
                              }
                              onChange={handleInputChange}
                            >
                              {field.options?.map((option) => (
                                <MenuItem key={option} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                          ) : field.name === 'note' ? (
                            <TextField
                              name={field.name}
                              value={newLog[field.name]}
                              onChange={handleInputChange}
                              fullWidth
                              margin='normal'
                              variant='outlined'
                              multiline
                              rows={3}
                            />
                          ) : field.name === 'password' ? (
                            <TextField
                              name='password'
                              type={showPassword ? 'text' : 'password'} // Show password if showPassword is true
                              value={newLog.password}
                              onChange={handleInputChange}
                              fullWidth
                              margin='normal'
                              variant='outlined'
                              sx={{
                                ...AUTOFILL_STYLES(theme),
                              }}
                              InputProps={{
                                endAdornment: (
                                  <IconButton
                                    aria-label='toggle password visibility'
                                    onClick={togglePasswordVisibility}
                                    edge='end'
                                  >
                                    {!showPassword ? (
                                      <VisibilityOff />
                                    ) : (
                                      <Visibility />
                                    )}
                                  </IconButton>
                                ),

                              }}
                            />
                          ) : field.name === 'attachments' ? (
                            <input type='file' />
                          ) : field.name === 'createddate' ? (
                            <TextField
                              name={field.name}
                              type='text'
                              value={formatDate(newLog.createdate)}
                              onChange={handleInputChange}
                              fullWidth
                              margin='normal'
                              variant='outlined'
                              InputProps={{ readOnly: true }}
                            />
                          ) : (
                            <TextField
                              name={field.name}
                              type={
                                field.type === 'date'
                                  ? 'date'
                                  : field.type === 'dropzone'
                                    ? 'dropzone'
                                    : 'text'
                              }
                              value={newLog[field.name]}
                              onChange={handleInputChange}
                              fullWidth
                              margin='normal'
                              variant='outlined'
                              sx={{
                                height: '20px',
                                marginBottom: 4,
                                ...AUTOFILL_STYLES(theme),
                              }}
                            />
                          )}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                )
            )}
          </Grid>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: '20px' }}>
            <Button
              type='submit'
              variant='contained'
              color='primary'
              sx={{ marginRight: '10px' ,'&:disabled': { bgcolor: 'grey.400', color: 'grey.700' } }}
              disabled={isSaving}
            >
              Save
            </Button>
            <Button variant='contained' onClick={handleCancelClick}>
              Cancel
            </Button>
          </Box>
        </form>
        <FloatingButton />
      </Box>
    </ThemeProvider>
  );
};

export default AddUserPage;
